<template>
  <div class="exam" id="expert">
    <!-- 大咖预约区 -->
    <div class="tit">
      <img src="@/assets/images/tit-exam.jpg" alt />
    </div>

    <div class="adviser-box" v-if="upsTeacherList.length > 0">
      <ul class="countryTab">
        <li v-for="(item,index) in countryList" :key="index" :class="{ active: item.id == countryId }" @click="countryId=item.id;tabItemId=0">{{ item.name }}</li>
      </ul>
      <p class="tips">向左滑动查看所有&gt;&gt;</p>
      <!-- 滑动查看更多大咖 >> -->
      <swiper class="swiper-container swiper" :options="swiperOptions" ref="mySwiper">
        <swiper-slide class="swiper-slide" :class="{active : item.teacherId == tabItemId}" v-for="(item,index) in itemList" :key="index">
          <div @click="tabItemId = item.teacherId" class="exam-icon">
            <!-- <span class="exam-icon-con">
              <i v-if="item.tags && item.tags.indexOf('法')>-1" class="exam-icon-contry1"></i>
              <i v-if="item.tags && item.tags.indexOf('德')>-1" class="exam-icon-contry2"></i>
            </span>-->

            <div class="img-box">
              <img :src="item.head" alt />
            </div>
            <p class="name">{{ item.name }}</p>
            <!-- <p class="type ofw-hide">{{ item.position }}</p> -->
            <span class="btn btn1" @click="tips(item.teacherId,item.upsId)" v-if="status <= 2 && isMake != item.teacherId">提前预约</span>
            <span class="btn btn2" @click="tips(item.teacherId,item.upsId)" v-else-if="status <= 2 && isMake == item.teacherId">预约成功</span>
            <span class="btn btn3" v-else>预约结束</span>
            <p class="exam-line"></p>
          </div>
        </swiper-slide>
      </swiper>

      <div class="con">
        <div class="top">
          <div class="type d-type1">
            <span class="text-1">{{ item.position }}</span>
            <b></b>
          </div>
          <div class="type">
            <span class="text-2">{{ item.introduction }}</span>
          </div>
          <!-- <div class="type">
            <span class="text-3">
              <span class="time-title">规划时间</span>9月19日 13:00-17:00 
            </span>
          </div>-->
        </div>

        <div class="bottom">
          <p class="ofw-hide-3">{{ item.abstract }}</p>
        </div>
      </div>
    </div>

    <Modal @appointment="appointment" @closeModal="modalType = -1" :type="modalType" :msg="modalmsg" :title="modaltitle" />
  </div>
</template>

<script>
import {
  getUpsTeacher,
  teacherSubscribe,
  checkTeacherSubscribe,
} from "@/api/home";
import Modal from "@/components/modal.vue";
export default {
  props: {
    isLogin: {
      type: Boolean,
      default: false,
    },
    expoId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Modal,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: "auto",
      },
      countryId: 0,
      tabItemId: 0,
      upsTeacherList: [], // 大咖咨询区老师
      modalType: -1,
      modalmsg: "",
      modaltitle: "",
      title: "大咖咨询区",
      desc: "留学大咖1V1咨询名额限量发放，先到先得",
      status: 0, //2可预约/3预约结束
      isMake: 0, //已预约大咖ID
      teacherId: "",
      upsId: "",
    };
  },
  computed: {
    countryList: {
      get: function () {
        if (this.upsTeacherList.length > 0) {
          return this.upsTeacherList.map((e) => {
            return { id: e.id, name: e.name.split("-")[0] };
          });
        }
      },
    },
    itemList: {
      get: function () {
        if (this.upsTeacherList.length > 0 && this.countryId > 0) {
          return this.upsTeacherList.filter((it) => it.id == this.countryId)[0]
            .teachers;
        } else {
          this.countryId = this.upsTeacherList[0].id;
          return this.upsTeacherList[0].teachers;
        }
      },
    },
    item: {
      get: function () {
        if (this.itemList.length > 0 && this.tabItemId > 0) {
          return this.itemList.filter(
            (it) => it.teacherId == this.tabItemId
          )[0];
        } else {
          this.tabItemId = this.itemList[0].teacherId;
          return this.itemList[0];
        }
      },
    },
  },
  methods: {
    countrychange(index) {
      this.countryIndex = index;
      this.upsTeacherIndex = 0;
    },
    //获取大咖列表
    async getUpsTeacher() {
      let res = await getUpsTeacher({
        params: {
          expoId: this.expoId,
        },
      });
      console.log(res);
      if (res.succ) {
        this.upsTeacherList = res.results;
        this.status = res.results[0].subscribeStatus;
        this.checkTeacherSubscribe();
      }
    },

    // 判断用户是否预约大咖
    async checkTeacherSubscribe() {
      let res = await checkTeacherSubscribe({
        expoId: this.expoId,
        upsId: this.upsTeacherList[0].teachers[0].upsId,
        teacherId: this.upsTeacherList[0].teachers[0].teacherId,
      });
      if (res.succ) {
        this.isMake = res.results.teacherId;
      }
    },

    // 点击弹出预约提示框
    tips(teacherId, upsId) {
      if (teacherId) {
        this.teacherId = teacherId;
        this.upsId = upsId;
      }
      if (!this.isLogin) {
        this.$emit("showLogin", "exam");
        return;
      }
      if (this.isMake > 0) {
        this.modalType = 2;
        this.modaltitle = "请勿重复预约";
        this.modalmsg =
          "您已经成功预约了一个大咖咨询服务，<br>不能重复预约，祝您咨询愉快。";
      } else {
        this.modalType = 0;
        this.modalmsg =
          "大咖预约只能预约一位，<br>预约后不可修改，请您进行确认?";
      }
    },

    async appointment() {
      const { code, succ } = await teacherSubscribe({
        expoId: this.expoId,
        upsId: this.upsId,
        teacherId: this.teacherId,
      });
      this.isShowModal = true;
      if (succ) {
        //当前时间
        let date = new Date();
        let now = date.getTime();
        //开始时间
        let startDate = new Date("2020/11/28 10:00:00");
        let start = startDate.getTime();
        //结束时间
        let endDate = new Date("2020/11/28 18:00:00");
        let end = endDate.getTime();

        if (now > start && now < end) {
          this.appointmentEnd();
        } else {
          this.modalType = 1;
          this.modaltitle = "您已成功预约";
          this.modalmsg =
            "您已提交申请，<br>我们的工作人员会尽快与您联系，请保持电话畅通。";
        }

        this.isMake = this.teacherId;
      } else {
        this.modalType = 2;
        this.modaltitle = "请勿重复预约";
        this.modalmsg =
          "您已经成功预约了一个大咖咨询服务，<br>不能重复预约，祝您咨询愉快。";
      }
    },
    appointmentEnd() {
      this.modalType = 2;
      this.modaltitle = "目前预约席位紧张";
      this.modalmsg = "我们的工作人员将为您联系安排，请保持电话通畅";
    },
  },

  created() {
    if (this.expoId) {
      this.getUpsTeacher();
    }
  },
  watch: {
    expoId(newVal) {
      if (newVal) {
        this.getUpsTeacher();
      }
    },
  },
};
</script>

<style lang="less">
.exam {
  background: #fff url(~@/assets/images/exam_bg.png) no-repeat left top;
  background-size: 100% auto;
  position: relative;
  padding-bottom: 0.52rem;
}
.exam-icon {
  position: relative;
  .exam-icon-con {
    height: 0.28rem;
    top: -0.15rem;
    right: 0;
    position: absolute;
    i {
      display: inline-block;
      margin-right: 0.1rem;
      width: 0.28rem;
      height: 0.28rem;
    }
    .exam-icon-contry1 {
      background: url(~@/assets/images/icon_fr.png) no-repeat;
      background-size: 100% 100%;
    }
    .exam-icon-contry2 {
      background: url(~@/assets/images/icon_ge.png) no-repeat;
      background-size: 100% 100%;
    }
  }
}

.exam .adviser-box {
  background-color: #f7fcfe;
  padding-bottom: 0.15rem;
  width: 6.9rem;
  margin: 0 auto;
  border: 0.02rem solid #97cbfa;
  border-radius: 0.1rem 0.1rem 0.2rem 0.2rem;
  .tips {
    font-size: 0.2rem;
    color: #666666;
    text-align: right;
    padding: 0.2rem 0.1rem 0.05rem;
  }
}

.exam .adviser-box .countryTab {
  display: flex;
  justify-content: space-around;
  background: linear-gradient(24deg, #97cbfa, #379af4);
  align-items: center;
  height: 0.76rem;
  padding: 0 0.3rem;
  border-radius: 0.1rem 0.1rem 0 0;
  li {
    padding: 0.02rem 0.15rem;
    //border-radius: 1rem;
    font-size: 0.26rem;
    font-weight: 900;
    color: #fff;
    &.active {
      background-color: #0358dd;
      border: 0.02rem solid #fff;
      border-radius: 0 0.16rem 0.16rem 0.16rem;
    }
  }
}

.exam .adviser-box .swiper {
  padding: 0rem 0.24rem 0.3rem;
}
.exam .adviser-box .swiper-slide {
  width: 2.05rem !important;
  height: 3.6rem;
  margin-right: 0.1rem;
  border-radius: 0.1rem;
  text-align: center;
  margin-top: 0.2rem;
}
.exam .adviser-box .swiper-slide.active {
  box-shadow: 0rem 0rem 0.3rem 0.05rem #eae6e7;
  background-color: #fff;
  .exam-line {
    border: 0.01rem solid #ff5156;
    width: 0.87rem;
    text-align: center;
    margin: 0.65rem auto;
  }
}
.exam .adviser-box .swiper-slide .img-box {
  width: 1.85rem;
  height: 1.85rem;
  border-radius: 50%;
  background-color: #e2e7f2;
  overflow: hidden;
  margin: 0.2rem auto 0.1rem;
}

.exam .adviser-box .swiper-slide .name {
  font-size: 0.28rem;
  font-weight: 900;
  padding-bottom: 0.2rem;
}
.exam .adviser-box .swiper-slide .type {
  font-size: 0.24rem;
  color: #666666;
  padding: 0.06rem 0;
}

.exam .adviser-box .swiper-slide .btn {
  float: right;
  width: 1.62rem;
  height: 0.48rem;
  line-height: 0.48rem;
  background-size: 0.23rem 0.23rem;
  background-position: 1.25rem center;
  margin-right: 0.24rem;
  margin-top: 0.02rem;
  color: #fff;
  font-size: 0.22rem;
  text-align: center;
  border-radius: 0.24rem;
}
.exam .adviser-box .swiper-slide .btn.btn1 {
  background-color: #fc6822;
}
.exam .adviser-box .swiper-slide .btn.btn2 {
  background-color: #1b76e8;
}
.exam .adviser-box .swiper-slide .btn.btn3 {
  background-color: #b2b0b0;
}

.exam .adviser-box .con {
  margin: 0rem 0.1rem 0;
  border: 0.01rem solid #67b2f7;
  padding: 0.26rem 0.1rem 0 0;
  border-radius: 0.1rem;
  background-color: #fff;
}
.exam .adviser-box .con .top .d-type1 {
  // background: url(~@/assets/images/exam-text-time.png) no-repeat;
  // background-size: 1.2rem 0.4rem;
  // background-position: 5rem 0.1rem;
}
.exam .adviser-box .con .top .type {
  padding: 0.1rem;
}
.exam .adviser-box .con .top span {
  text-align: left;
  padding-left: 0.21rem;
  background: url(~@/assets/images/icon_tu1.png) no-repeat;
  background-size: 0.15rem 0.15rem;
  background-position: 0.08rem 0.1rem;
  padding-left: 0.35rem;
}

.exam .adviser-box .con .top span.text-1 {
  width: 2.23rem;
  height: 0.28rem;
  font-size: 0.28rem;
  font-family: SourceHanSansCN;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  line-height: 0.28rem;
}
.exam .adviser-box .con .top .text-2 {
  font-size: 0.24rem;
  display: inline-block;
  color: #666;
}
.exam .adviser-box .con .top .text-3 {
  width: 1.94rem;
  height: 0.2rem;
  font-size: 0.22rem;
  font-weight: 500;
  color: #2fbde6;
  font-weight: 500;
  .time-title {
    background: #fff;
    margin-right: 0.1rem;
    padding: 0 0.1rem 0.03rem;
  }
}

.exam .adviser-box .con .bottom {
  padding-left: 0.45rem;
  background: url(~@/assets/images/icon_tu1.png) no-repeat;
  background-size: 0.15rem 0.15rem;
  background-position: 0.2rem top;
  font-size: 0.24rem;
  margin-top: 0.1rem;
  margin-bottom: 0.3rem;
}
.exam-box {
  margin: 0.36rem 0.24rem 0.23rem;
  background-color: #fff;
  border-radius: 0.1rem;
}
.exam-box .tit {
  padding: 0.66rem 0.24rem 0;
  /* background: url(~@/assets/images/adviser_titbj.png) no-repeat; */
  background-size: 100% 100%;
  position: relative;
}
.exam-box .tit img {
  width: 1.25rem;
  position: absolute;
  right: 0.24rem;
  top: 0.7rem;
}
.exam-box .list {
  margin-top: 0.36rem;
  padding-bottom: 0.5rem;
}
.exam-box .list li {
  background: #fcfaf8;
  border: 0.02rem solid #f77329;
  padding: 0.35rem 0.2rem;
  border-radius: 0.1rem;

  margin: 0 0.24rem 0.24rem;
}
.exam-item {
  display: flex;
  justify-content: space-between;
  padding-bottom: 0.16rem;
  border-bottom: 1px solid #d6d5d5;
}
.exam-memo {
  padding: 0.25rem 0 0.15rem;
  font-size: 0.22rem;
  line-height: 0.28rem;
  color: #333;
}
.exam-box .list li .left {
  width: 1.8rem;
  margin-right: 0.3rem;
}
.exam-box .list li .left .img-box {
  width: 1.8rem;
  height: 1.8rem;
  border-radius: 50%;
  background-color: #e1e5eb;
  overflow: hidden;
}
.exam-box .list li .left .img-box img {
  width: 100%;
  height: 100%;
}
.exam-box .list li .left .btn {
  display: block;
  width: 1.62rem;
  height: 0.48rem;
  line-height: 0.48rem;
  text-align: center;
  color: #fff;
  font-size: 0.24rem;
  font-weight: 900;
  margin: -0.3rem auto 0;
  border-radius: 0.24rem;
  position: relative;
}
.exam-box .list li .left .btn.btn-1 {
  background-color: #f04441;
}
.exam-box .list li .left .btn.btn-2 {
  background-color: #06cd8a;
}
.exam-box .list li .left .btn.btn-3 {
  background-color: #aeb5bd;
}
.exam-box .list li .right {
  width: 4rem;
  padding-top: 0.25rem;
}
.exam-box .list li .right span {
  display: block;
  width: 1.2rem;
  height: 0.32rem;
  line-height: 0.32rem;
  color: #fff;
  font-size: 0.2rem;
  text-align: center;
  background-color: #28b1ff;
  border-radius: 5rem;
  margin-top: 0.1rem;
  margin-bottom: 0.1rem;
}
.exam-box .list li .right h4 {
  font-size: 0.36rem;
  font-weight: 700;
  padding-bottom: 0.1rem;
  margin-bottom: 0.1rem;
  color: #f77329;
}
.exam-box .list li .right .p1 {
  font-size: 0.26rem;
  font-weight: 900;
}
.exam-box .list li .right .p2 {
  font-size: 0.26rem;
  color: #999;
}
.exam .ads {
  margin: 0 0.24rem;
  height: 1.48rem;
}
.exam .ads img {
  width: 100%;
  height: 100%;
}
</style>